import { PermissionRequirement } from './permission.model';

/** Permisos tenant resource `reports_ingresos_egresos` (paridad Rails `Reports::FinancialController#ingresos_egresos`). */
export const REPORTS_INGRESOS_EGRESOS_PERMISSIONS = {
  show: { resource: 'reports_ingresos_egresos', action: 'show' },
} as const satisfies Record<string, PermissionRequirement>;

/** Permisos tenant resource `pos_reports` (informe de ventas POS, paridad Rails). */
export const REPORTS_POS_SALES_PERMISSIONS = {
  show: { resource: 'pos_reports', action: 'show' },
} as const satisfies Record<string, PermissionRequirement>;
